module.exports = __webpack_public_path__ + "static/media/hiv_in_women_mobile.8228b282.jpg";